// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('FeedEmptyMessage')

function createEmptyMessage(template) {
  function EmptyMessage(props) {
    return tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      template(props)
    )
  }

  EmptyMessage.propTypes = {
    className: PropTypes.string
  }

  return EmptyMessage
}

module.exports = createEmptyMessage
